import { render, staticRenderFns } from "./autoReward.vue?vue&type=template&id=0c41433f&scoped=true"
import script from "./autoReward.vue?vue&type=script&lang=js"
export * from "./autoReward.vue?vue&type=script&lang=js"
import style0 from "./autoReward.vue?vue&type=style&index=0&id=0c41433f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c41433f",
  null
  
)

export default component.exports